import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage/Homepage";
import Objectives from "./pages/AboutUs/Objectives";
import NavMenu from "./Components/NavMenu";
import Activities from "./pages/Activities/Activities";
import Partners from "./pages/AboutUs/Partners";
import News from "./pages/News/News";
import Gallery from "./pages/Gallery/Gallery";
import Footer from "./Components/Footer";
import "./App.css";
import NotFoundPage from "./pages/NotFound/NotFoundPage";
import NewsDetails from "./pages/News/NewsDetails";

//translations
import "./i18n/config";

function App() {
  return (
    <Router>
      <div className="app-container">
        <NavMenu />
        <div className="content">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/about-us/objectives" element={<Objectives />} />
            <Route path="/about-us/partners" element={<Partners />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/details/:id" element={<NewsDetails />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
